import ProductListRow from './ProductListRow';

export default ProductListRow;
